import Vue, { PropType } from 'vue';
import { CellType, ICell, IClue } from 'js/crossword/types';

import ClueCell from "./boardCells/ClueCell";
import EmptyCell from "./boardCells/EmptyCell";
import IdentifierCell from "./boardCells/IdentifierCell";
import RegularCell from "./boardCells/RegularCell";

import getCellClasses from "./boardCells/getCellClasses";

export default Vue.extend({
  data() {
    return {
      enlarge: false,
    };
  },
  props: {
    cell: Object as PropType<ICell>,
    currentClue: Object as PropType<IClue>,
    currentCellId: String,
    puzzleColumns: Number,
    puzzleRows: Number,
    print: Boolean,
  },
  computed: {
    activeCell(): boolean {
      return this.cell.id === this.currentCellId;
    },
    currentClueCell(): boolean {
      if (this.activeCell || !this.currentClue) return false;
      return this.currentClue.cells.includes(this.cell.id);
    },
  },
  methods: {
    handleHover(hovering: boolean) {
      if (!this.cell.arrow) return;
      this.enlarge = hovering;
    },
  },
  render() {
    const componentMap = {
      [CellType.Clue]: ClueCell,
      [CellType.Empty]: EmptyCell,
      [CellType.Regular]: RegularCell,
      [CellType.Identifier]: IdentifierCell,
    };
    const CellComponent = componentMap[this.cell.type];
    const {
      activeCell,
      cell,
      currentClueCell,
      enlarge,
      puzzleColumns,
      puzzleRows,
      print,
    } = this;

    const classes = getCellClasses(cell, { print, currentClueCell, activeCell });

    return (
      <div
        class={classes}
        onClick={() => this.$emit("cellClicked", this.cell)}
        onmouseover={() => this.handleHover(true)}
        onmouseleave={() => this.handleHover(false)}
      >
        <CellComponent
          cell={cell}
          enlarge={enlarge}
          puzzleColumns={puzzleColumns}
          puzzleRows={puzzleRows}
          onClueClicked={(clueId) => this.$emit("clueClicked", clueId)}
        />
      </div>
    );
  },
});
